import { cn } from "@/lib/utils";

const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_quality-oversight/artifacts/5c8lms6d_ChatGPT%20Image%20Mar%2011%2C%202026%2C%2003_43_39%20PM.png";

export default function BrandLogo({
  className = "",
  iconClassName = "",
  layout = "full",
  tone = "default",
  wordmarkClassName = "",
}) {
  const toneClassName = tone === "watermark" ? "opacity-12" : "opacity-100";
  const imageTransform =
    layout === "mark" ? "scale(1.46) translateY(2.5%)" : "scale(1.62) translateY(2.5%)";

  return (
    <div className={cn("inline-flex items-center", className, wordmarkClassName)}>
      <div className={cn("overflow-hidden", iconClassName)}>
        <img
          alt="BuildTech logo"
          className={cn("h-full w-full object-contain object-center", toneClassName)}
          src={LOGO_URL}
          style={{ transform: imageTransform, transformOrigin: "center center" }}
        />
      </div>
    </div>
  );
}